module.exports = __webpack_public_path__ + "static/media/org_inactive.2c4aed2c.svg";